<template>

<b-container class="content" >

    <b-row>    
      <b-col class="row-item leftcol" >
        <div class="componentcontainer">
            <!-- rdx,rdy:  Dam square Amsterdam -->
            <ThreeViewer :showTileGrid="false" :rdx="121393" :rdy="487334" :tileRadius="500" ></ThreeViewer>
        </div>
      </b-col>

  </b-row>


  <b-row>    
      <b-col class="row-item" >
        <h2>Digitale participatie in Amsterdam</h2>
        <div>
          AmsterdamAR is een project dat onderzoekt hoe we bewoners op een inspirerende manier kunnen betrekken bij de toekomst van hun wijk. 
  Dit doen we met nieuwe technologieën, zoals een 360-graden verkenning in de openbare ruimte middels een QR-code, en een AR-maquette waarmee je een nieuwbouwproject op je tafel kunt projecteren.
</div>  
      </b-col>
  </b-row>

  <modelrow :title="'AR Maquette'"
            short-code="Sr3a"
            :add-model-viewer="false"
            :allow-scale="true"
            :description="'Deze demo laat zien hoe een nieuw bouwproject kan worden gepresenteerd als een AR-model, waardoor belanghebbenden uit de gemeenschap, de bewoners van de buurt, actief kunnen deelnemen aan de ontwikkeling van het project. Door gebruik te maken van augmented reality-technologie kunnen bewoners de voorgestelde plannen visualiseren en ermee interageren, wat waardevolle input en feedback oplevert om de toekomst van hun gemeenschap vorm te geven.'"
            :model-src="assetUrl('models/Wildemanbuurt/WildemanV4_maquette.glb')"
            :ios-src="assetUrl('models/Wildemanbuurt/WildemanV4_maquette.usdz')"
            :background-color="'#F5F5F5'"
            :qr-code-size="150">
  </modelrow>

  <modelrow :title="'360 Verkenning'"
            short-code="ciRr"
            route-prefix="360"
            :add-model-viewer="false"
            :allow-scale="false"
            :description="'Deze demo laat zien hoe we 360-graden verkenningen inzetten in de openbare ruimte. Door een QR-code te scannen kunnen bewoners en passanten direct rondkijken in de nieuw te realiseren plannen. Dit maakt het mogelijk om op een laagdrempelige manier een realistisch beeld te krijgen van de toekomstige situatie, gewoon vanaf de straat.'"
            image-src="/images/360.png"
            background-color="#ffffff"
            :qr-code-size="150">
  </modelrow>


</b-container>

</template>

<script>

import '@google/model-viewer';
import VueQRCodeComponent from 'vue-qrcode-component'
import ModelRow from '../components/ModelRow.vue';
import ThreeViewer from '../components/ThreeViewer.vue';
import { assetUrl } from '@/assetConfig';

export default {
  name: 'Home',
  data: function () {
    return{
      isAndroid: false,
      isIPhone: false,
      isMobile: false,
      theteam:team,
      modelDataUrl: ''
    }
  },
  computed:{    
  },
  watch: {
  },
  created:function(){    
  },
  mounted:function(){
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice); 
    const modelViewer = this.$refs.androidmodel;

    // document.addEventListener("fullscreenchange", () => {

      
    // });

  },
 methods: {
  assetUrl,
  checkDevice() {
      // Controleer of het een mobiel apparaat is (bijv. iPhone)
      this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      this.isAndroid = /Android/.test(navigator.userAgent);
      this.isIPhone = /iPhone/.test(navigator.userAgent);
    }
 },
  components: {
    'qr-code': VueQRCodeComponent,
    'modelrow': ModelRow,
    ThreeViewer
  },
  beforeDestroy() {
    // Verwijder de event listener bij het vernietigen van de component
    window.removeEventListener('resize', this.checkDevice);
  },
}
</script>

<style>

a {
  color: inherit;
  text-decoration: none;
  font-weight: bold;
}

a:hover {
  text-decoration: underline;
}

h1{
  font-family: AvenirBold;
  font-size: 34px;  
}

p{
  margin-left: 50px;
  margin-right: 50px;
  margin-top: 40px;
  margin-bottom: 40px;
}



h1.fronttext {
  top: 12px;
  left: 20px;
  z-index: 2;
  font-size: 2.5rem;
}

p.fronttext {
  top: 58px;
  left: 20px;
  z-index: 1;
  margin-top: 20px;
}

.imgtext{
  width: 100%;
  position: absolute;
  background-color: rgba(105, 28, 28, 0.14);
  z-index: 1;
  height:580px;
}

@media (max-width: 768px) {
  h1{
    margin-left: 20px;
    margin-right: 20px;
  }

  p{
    margin-left: 20px;
    margin-right: 20px;
  }

  p.fronttext {
    top: 100px;
  }

}


@media (min-width: 576px){
  .imgtext{
    height:405px;
  }
}

@media (min-width: 768px){
  .imgtext{
    height:305px;
  }
}

@media (min-width: 992px){
  .imgtext{
    height:245px;
  }
}

@media (min-width: 1200px){
  .imgtext{
    height:215px;
  }
}

.fronttext{
color:#fff;
}

h2{
  font-family: AvenirBold;
   font-size: 24px;
}

.content{
  text-align: left;
  font-family: AvenirMedium;
  font-size: 20px;  ;  
}

.header {
  position: relative;
  width: 100%;
  height: auto;
}

.main-image-container {
  width: 100%;
  height: 740px;
  position: relative;
  overflow: hidden;
}

.main-image {
  width: 100%; 
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.artimpression {
  color:#ffffff;
  /* background-image: url('/images/art-impression-blend1.png'); */
height: 100%;
  background-color: #01489A;

  background-size: cover; /* Zorgt ervoor dat de afbeelding de hele kolom vult */
  background-position: center; /* Centreert de afbeelding */
  background-repeat: no-repeat; /* Voorkomt herhaling */
}

.overlaytext{
  background-color: rgb(119 97 70 / 50%);
  padding: 20px;
}

.fronttext {
  position: absolute;
  color: white;
  padding: 5px;
}

.qr-image{
  max-width: 200px;
}

.buttons{
 padding: 40px; 
}

.row-item{
  font-size: 16px;
  padding: 24px;
  margin-left: auto;
  margin-right: auto;
}

.col{
  min-width: 400px;
}

.leftcol{
  min-height: 400px;
}

.componentcontainer{
  width: 100%;
  height: 100%;
}

.linkcard{
  width: 50%;
  max-width: 50%;
  padding: 20px;
  margin-left: auto;
  margin-right: auto;
}

.col-center{
  padding-top: 20px;
  text-align: center;
}

.avatar{
   border-radius: 50%;
   width: 44px;
}

.avatar-col{  
  flex: 0 0 48px !important;
  min-width: 48px;
  padding: 0px;
}

.team-col{  
  overflow: hidden;
}

.team{
  font-size: 16px;
  font-family: AvenirRegular;  
}

.teamrow{
  width: 300px;
  margin-top:10px;
  margin-bottom:10px;
  margin-left: 40px;
}

.email, .links a, .links a:visited{
  color: rgb(118, 142, 158);  
}

.button-link{
  margin-top:20px;
  margin-bottom: 20px;
  background-color: #01489A;
}

.spacer{
margin-top:10px;
}

</style>
